import * as types from './types';
import { INITIAL_DENOMINATIONS_STATE } from 'Common/Components/CashCalculator/constants';

import { extractDenominations, formatCheckData } from '../helpers/helper';

const initialState = {
  loading: false,
  summary: null,
  error: null,
  amount: {
    opening: 0,
    closing: 0,
  },
  openingCashCalc: {
    denominations: INITIAL_DENOMINATIONS_STATE,
    checks: [],
  },
  closingCashCalc: {
    denominations: INITIAL_DENOMINATIONS_STATE,
    checks: [],
  },
  users: [],
  dayClosed: false,
  summaryRan: false,
  userSites: [],
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case types.MEAL_SUMMARY:
      return {
        ...state,
        summary: payload.summary,
        summaryRan: true,
        amount: {
          opening: parseFloat(payload.openingAmount),
          closing: parseFloat(payload.closingAmount),
        },
      };

    case types.MEAL_SUMMARY_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.MEAL_SUMMARY_FETCHING_USER_AND_SUMMARY_AMOUNT:
    case types.MEAL_SUMMARY_FETCHING_SUMMARY_CHECKS:
    case types.MEAL_SUMMARY_LOADING_SUMMARY_AMOUNTS:
    case types.MEAL_SUMMARY_WRITING_CASH_AND_CHECKS:
    case types.MEAL_SUMMARY_WRITING:
      return {
        ...state,
        loading: payload,
      };

    case types.MEAL_SUMMARY_AMOUNTS: {
      const openingDenominations = extractDenominations(payload.BegCash);
      const closingDenominations = extractDenominations(payload.EndCash);
      const openingChecks = formatCheckData(payload.BegChecks);
      const closingChecks = formatCheckData(payload.EndChecks);

      const openingCashCalc = {
        denominations: openingDenominations,
        checks: [],
      };
      const closingCashCalc = {
        denominations: closingDenominations,
        checks: [],
      };

      if (payload.SummaryRan) {
        openingCashCalc.checks = openingChecks;
        closingCashCalc.checks = closingChecks;
      }

      return {
        ...state,
        amount: {
          opening: payload.OpenAmount,
          closing: payload.CloseAmount,
        },
        summaryRan: payload.SummaryRan,
        dayClosed: payload.IsClosed,
        openingCashCalc,
        closingCashCalc,
      };
    }

    case types.MEAL_SUMMARY_UPDATE_OPENING_CASH_CALC:
      return {
        ...state,
        openingCashCalc: {
          denominations: payload.denominations,
          checks: payload.checks,
        },
      };

    case types.MEAL_SUMMARY_UPDATE_CLOSING_CASH_CALC:
      return {
        ...state,
        closingCashCalc: {
          denominations: payload.denominations,
          checks: payload.checks,
        },
      };

    case types.MEAL_SUMMARY_GET_USERS:
      const users = payload.map((option, index) => {
        return { value: option.Id, key: option.Id, text: option.UserName };
      });

      return {
        ...state,
        users,
      };

    case types.MEAL_SUMMARY_OPENING_CHECKS:
      return {
        ...state,
        openingCashCalc: {
          ...state.openingCashCalc,
          checks: payload,
        },
      };

    case types.MEAL_SUMMARY_CLOSING_CHECKS:
      return {
        ...state,
        closingCashCalc: {
          ...state.closingCashCalc,
          checks: payload,
        },
      };

    case types.MEAL_SUMMARY_CLEAR_STATE:
      return {
        ...state,
        amount: {
          opening: 0,
          closing: 0,
        },
        openingCashCalc: {
          denominations: INITIAL_DENOMINATIONS_STATE,
          checks: [],
        },
        closingCashCalc: {
          denominations: INITIAL_DENOMINATIONS_STATE,
          checks: [],
        },
        dayClosed: false,
        summaryRan: false,
      };

    case types.MEAL_SUMMARY_CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/mealsummary/state/reducer.js